$(document).ready(function() {
    $('.product__media').izoomify();
    $('.pplr_preview_wrapper').izoomify();
        $('#special-order-checkbox').on('click change', function() {
            var isChecked = $(this).is(':checked');
                if (isChecked) {
                    $('.custom-special-order .cart__contents').show();
                } else {
                    $('.custom-special-order .cart__contents').hide();
                }
            }
        );
        var active_image_eq = $('.product__media-item.is-active').index();
        var prod_image_count = $('.product__media-item').length;
        if(prod_image_count == 1){
            $('.main-image-arrow.custom-left-arrow').hide();
            $('.main-image-arrow.custom-right-arrow').hide();
        }
        if(active_image_eq == 0){
            $('.main-image-arrow.custom-left-arrow').prop("disabled", true);
        }
    $('.main-image-arrow.custom-right-arrow').click(function(){
        $('.main-image-arrow.custom-left-arrow').prop("disabled", false);
        $('.product__media-item.is-active').removeClass('is-active');
        $('.product__media-item').eq(active_image_eq+1).addClass('is-active');
        active_image_eq++;
        if(active_image_eq>=prod_image_count-1){
            $(this).prop("disabled", true);
        }
    });
    $('.main-image-arrow.custom-left-arrow').click(function(){
        $('.main-image-arrow.custom-right-arrow').prop("disabled", false);
        $('.product__media-item.is-active').removeClass('is-active');
        $('.product__media-item').eq(active_image_eq-1).addClass('is-active');
        active_image_eq--;
        if(active_image_eq<1){
            $(this).prop("disabled",true);
        }
    });
    $('.thumbnail-list__item').click(function(){
        var get_current_image_thumbnail = $(this).data('media-position');
        if(get_current_image_thumbnail == prod_image_count){
            active_image_eq = get_current_image_thumbnail+1;
            $('.main-image-arrow.custom-right-arrow').prop("disabled", true);
            
        }
        if(get_current_image_thumbnail == 1){
            active_image_eq = get_current_image_thumbnail-1;
            $('.main-image-arrow.custom-left-arrow').prop("disabled", true);
           
        }
        if(get_current_image_thumbnail > 1){
            $('.main-image-arrow.custom-left-arrow').prop("disabled", false);
        }
        active_image_eq = get_current_image_thumbnail-1;
    });

    if ($('.custom-multi-row-section').length > 2) {
        $('.custom-multi-row-section').slice(2).addClass('hidden');

    }
        $('.custom-show-more').on('click', function() {
        var items = $('.custom-multi-row-section');
        var second = items.eq(1); // Get second index for custom-multi-row-section
        var scrollPos = second.scrollTop();
        if(items.hasClass('hidden')){
            items.slice(2).removeClass('hidden').css('visibility','visible'); // Show More
            $(this).text('Show Less');
        }
        else{
            items.slice(2).css('visibility','hidden');// Show Less
            $('html, body').animate({
            scrollTop: second.offset().top
            }, 50); // Scrolls back to the second index
            setTimeout(function(){
                items.slice(2).addClass('hidden');
            }, 1000); // Delays hiding the elements so that the scrolling finishes before hiding
            $(this).text('Show More');
        }
    });

    const lazyLoadInstance = new LazyLoad();

    const observer = new MutationObserver((mutations) => {
    let needsUpdate = false;
    for (const mutation of mutations) {
        if (mutation.type === 'childList') {
        // check if new nodes added contain elements matching your selector"
        mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches && node.matches('.lazy')) {
            needsUpdate = true;
            }
            // if node contains lazy‐children
            if (node.nodeType === 1) {
            const lazyChildren = node.querySelectorAll && node.querySelectorAll('.lazy');
            if (lazyChildren && lazyChildren.length > 0) {
                needsUpdate = true;
            }
            }
        });
        }
        // check for attribute changes if you're converting elements to lazy‐loading
    }

    if (needsUpdate) {
        lazyLoadInstance.update();
    }
    });

    // Start observing the container that will have new content (e.g., document.body or a specific container)
    observer.observe(document.body, {
    childList: true,
    subtree: true
    });

});

$(window).on("load", function() {
   if($('.product__media-item.is-active').index() == 0 ){
    $('.main-image-arrow.custom-left-arrow').prop("disabled", true);
   }
    $('.custom-submit-to-cart-button').on('click',function(){
         setTimeout(function() {
        window.location.href = "https://housesensationsart.com/cart";
        }, 1500); 
    });
});